import { useMediaQuery } from "@mui/system";
import { useEffect, useRef } from "react";
import { theme } from "./../../config/muiTheme";

export default function AudioVisualizer({
  isListening,
  audioLevel = [],
  component,
}) {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const previousDataRef = useRef([]);

  // Smooth incoming data
  const smoothedData = audioLevel.map((val, i) => {
    const prev = previousDataRef.current[i] || 0;
    return prev * 0.7 + val * 0.3;
  });

  useEffect(() => {
    if (audioLevel.length) previousDataRef.current = smoothedData;
  }, [audioLevel, smoothedData]);

  if (!isListening) return null;

  // Create visualization bars
  return (
    <div
      style={{
        position: "absolute",
        left: isMobileView ? "45%" : "50%",
        width: isMobileView ? "60%" : "50%",
        bottom: component === "legalChat" ? "60%" : "30%",
        transform: "translateX(-50%)",
        height: "18px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-evenly",
        pointerEvents: "none",
        zIndex: 1,
      }}
    >
      {/* Generate 80 bars for visualization */}
      {Array(50)
        .fill(0)
        .map((_, index) => {
          // Use provided data or generate placeholder pattern when no real data
          const value =
            audioLevel.length > 0
              ? smoothedData[index] || 0
              : index % 5 === 0
              ? 8
              : 0; // Placeholder pattern

          return (
            <div
              key={index}
              style={{
                marginLeft: "1px",
                marginRight: "1px",
                backgroundColor: "#303f9f",
                borderRadius: "999px",
                height: `${Math.max(1, value)}px`,
                width: "2px",
                transform: `translateY(${index % 2 === 0 ? "-" : ""}${
                  value / 4
                }px)`,
              }}
            />
          );
        })}
    </div>
  );
}
